import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../../../types/titles';
import WithdrawSelectTwoFaLayout from '../../../../components/withdraw/twofa/select-two-factor';

const WithdrawSelectTwoFa = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.WITHDRAW.TWO_FA.SELECT_TWO_FA}</title>
			</Helmet>
			<WithdrawSelectTwoFaLayout />
		</>
	);
};

export default WithdrawSelectTwoFa;
